export type RouterPaths = {
    ROOT: string;
    CHECKOUT: string;
    POST_SALE: string;
};

/*
 * It path is empty the Switch does not computed the matched path, it just returns true
 * This seems to be fixed in react-router v6
 */
export const routePathGenerator = (basePath: string): RouterPaths => ({
    ROOT: basePath.replace('new_label', '') || '/',
    CHECKOUT: basePath || '/',
    POST_SALE: `${basePath}/confirmation/:shipmentReference`,
});
